import Vue from 'vue';
import messagebox from './messagebox.vue';
import lang from '@/i18n/locale';
const MessageBox = Vue.extend(messagebox); // 创建的是一个组件构造器，不是实例
const Msg = (options) => {
  if (typeof options != 'object') {
    throw TypeError(`MessageBox options must be Object`);
  }
  let instance = new MessageBox({
    data: {
      ...options
    }
  }).$mount();
  document.body.appendChild(instance.$el); // 添加dom元素
  return instance;
};

Msg.vip = (option) => {
  let defaultOption = {
    type: 'vip',
    title: lang['action_limit'],
    confirmBtnText: lang['get_senior_member'],
    confirm: (val) => {
      let url =
        lang.lang_type == 'cn'
          ? 'https://www.elfinbook.com/senior_member'
          : 'https://www.elfinbook.com/en/senior_member';
      window.open(url);
    },
    cancel() {}
  };
  if (typeof option == 'string') {
    option = {
      message: option
    };
  }
  Msg({ ...defaultOption, ...option });
};

export default Msg;
